
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donaciones",
      function () {
        return require("private-next-pages/donaciones/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donaciones"])
      });
    }
  